/**
 * Created by user on 2019/4/28.
 */
import createRequestPromise, { IRequestPromise } from './create';

export const request = createRequestPromise();

export default request
